exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advert.card[data-v-4710f20c] {\n  min-height: 280px;\n  padding: 2rem 1.25rem 2.5rem;\n  position: relative;\n}\n.advert.card > a[data-v-4710f20c] {\n  color: white;\n  text-align: center;\n  font-size: 1.125rem;\n  text-decoration: none;\n  padding: 15px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}", ""]);

// exports
